import { makeStyles } from '@material-ui/core/styles';

const textDefault = (theme) => ({
  color: theme.palette.text.primary,
  fontSize: '1.125rem',
});

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  details: {
    width: '25%',
    marginBottom: '1.5rem',
  },
  title: {
    ...textDefault(theme),
    textDecoration: 'underline',
    fontWeight: '500',
  },
  content: {
    overflowY: 'auto',
    height: '26rem',
    ...textDefault(theme),
    marginTop: '2.5rem',
    marginLeft: '1rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '2rem',
  },
  loader: {
    display: 'flex',
    gap: '1rem',
  },
  loaderInformation: {
    paddingTop: '0.2rem',
    fontSize: '0.8rem',
  },
}));

export default useStyles;
